import { Flex, Text, Menu, Spoiler, Badge, Progress, Button, Rating } from "@mantine/core";
import { PipelineData } from "./Pipeline";
import ImageObserved from "./Image";
import { observer } from "mobx-react";
import { useState } from "react";
import { useStore } from "../../../hooks/use-store";
import { PLAN_TYPE } from "../../../types";
const image = '240px'
const bigImage = '440px'

const PipelineItem = (model: {
    rating: number
    secretModeEnabled: boolean
    audiThMode: boolean
    ravMode: boolean
    dark: boolean,
    pipeline: PipelineData,
    onEnlarge: (image: string) => void,
    onUpscale: (image: string, type: 'TOPAZ' | 'TOPAZ_ENHANCED' | 'FREEPIK') => void,
    onUpscaleHdrV1: (image: string, type: '4k' | '6k' | '8k') => void,
    onMoodEnhance: (image: string) => void,
    onAiRetouch2: (image: string) => void,
    changeBackground: (image: string) => void,
    onCameraRotate: (image: string) => void,
    onAiRetouch3: (image: string) => void,
    onInpaint: (image: string) => void,
    makeVariations: (image: string) => void,
    createHDR: (image: string) => void,
    create360: (image: string) => void,
    onCreateImageKling: (image: string) => void,
    onCreateImageVeo: (image: string) => void,
    onCreateImageHailuo: (image: string) => void,
    onCreateImageSeedance: (image: string) => void,
    onCreateImageWan: (image: string) => void,
    addFeatured: (id: string) => void,
    searchInHdrMaground: (image: string) => void,
    searchInMaground: (image: string) => void,
    onRemoveObject: (image: string) => void,
    onFillCarObject: (image: string) => void,
    fixWhiteBalance: (image: string) => void,
    placeCar: (image: string) => void,
    openBillingModal: () => void,
    openCustomModelVersion: (version: string, prompt: string, ratio: string) => void,
    onUpdateRating: (rating: number) => void,
    big?: boolean
}) => {

    const {
        dataStore: { spaceStore },
        uiStore: { authStore },

    } = useStore();

    const [opened, setOpened] = useState(false);
    const [hoveredSrc, setHoveredSrc] = useState<string | null>(null);


    const renderMenu = (src: string, types: ('edit' | 'cgi' | 'animate' | 'car')[], show: boolean, additionalSrc?: { type: 'changeBackground', src: string }[]) => {
        return (
            <>


                {
                    authStore?.currentUser?.plan === PLAN_TYPE.TRIAL_V1 ? null :
                        <Flex
                            pos={'absolute'}
                            bottom={'48%'}
                            left={10}
                            right={10}
                            w={'100%'}
                            justify={'center'}
                            align={'center'}

                        >
                            <Button
                                component={"a"}
                                href={src}
                                target={"_blank"}

                                color="orange"
                                size="xs"
                                variant="filled"
                                style={{ zIndex: 1, paddingLeft: 8, paddingRight: 8, opacity: show ? 1 : 0, pointerEvents: show ? 'auto' : 'none', transition: 'opacity 150ms ease-in-out' }}
                                styles={{
                                    root: {
                                        paddingLeft: 8,
                                        paddingRight: 8
                                    },
                                    leftIcon: {
                                        marginRight: 4
                                    }
                                }}
                                leftIcon={
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 7.33325V11.3333L7.33333 9.99992" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M6.00033 11.3333L4.66699 10" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M14.6663 6.66659V9.99992C14.6663 13.3333 13.333 14.6666 9.99967 14.6666H5.99967C2.66634 14.6666 1.33301 13.3333 1.33301 9.99992V5.99992C1.33301 2.66659 2.66634 1.33325 5.99967 1.33325H9.33301" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M14.6663 6.66658H11.9997C9.99967 6.66658 9.33301 5.99992 9.33301 3.99992V1.33325L14.6663 6.66658Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                }

                                download='test.png'

                            >
                                Download
                            </Button>
                        </Flex>

                }

                <Flex
                    style={{
                        zIndex: 1,
                        opacity: show ? 1 : 0,
                        pointerEvents: show ? 'auto' : 'none',
                        transition: 'opacity 150ms ease-in-out'
                    }}
                    pos={'absolute'}
                    top={0}
                    p={10}
                    left={0}
                    w={
                        '100%'
                    }
                    justify={'space-between'}
                    align={'center'}>

                    <Flex justify={'space-between'} gap={10} w={
                        '100%'
                    }>
                        <Flex gap={10}>
                            {
                                types.includes('edit') && (
                                    <Menu shadow="md">
                                        <Menu.Target>
                                            <Button

                                                color="orange"
                                                // p={8}
                                                size="xs"
                                                variant="filled"
                                                styles={{
                                                    root: {
                                                        paddingLeft: 8,
                                                        paddingRight: 8
                                                    },
                                                    leftIcon: {
                                                        marginRight: 4
                                                    }
                                                }}
                                                style={{ zIndex: 1, paddingLeft: 8, paddingRight: 8 }}
                                                leftIcon={
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2.33346 13.6667C2.88679 14.22 3.78012 14.22 4.33346 13.6667L13.0001 5.00002C13.5535 4.44669 13.5535 3.55336 13.0001 3.00002C12.4468 2.44669 11.5535 2.44669 11.0001 3.00002L2.33346 11.6667C1.78012 12.22 1.78012 13.1134 2.33346 13.6667Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M12.0068 5.99335L10.0068 3.99335" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M5.6665 1.62665L6.6665 1.33331L6.37317 2.33331L6.6665 3.33331L5.6665 3.03998L4.6665 3.33331L4.95984 2.33331L4.6665 1.33331L5.6665 1.62665Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M3 5.62665L4 5.33331L3.70667 6.33331L4 7.33331L3 7.03998L2 7.33331L2.29333 6.33331L2 5.33331L3 5.62665Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M13 8.96002L14 8.66669L13.7067 9.66669L14 10.6667L13 10.3734L12 10.6667L12.2933 9.66669L12 8.66669L13 8.96002Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }
                                            >
                                                Edit
                                            </Button>
                                        </Menu.Target>
                                        <Menu.Dropdown>
                                            <Menu.Item icon={
                                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.83325 7.33099V6.67765C1.83325 3.34432 3.16659 2.01099 6.49992 2.01099H10.4999C13.8333 2.01099 15.1666 3.34432 15.1666 6.67765V10.6777C15.1666 14.011 13.8333 15.3443 10.4999 15.3443H9.83325" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M9.16675 8.01097L12.5067 4.66431H9.83341" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M12.5066 4.66431V7.33764" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M7.83325 11.4442V13.2442C7.83325 14.7442 7.23325 15.3442 5.73325 15.3442H3.93325C2.43325 15.3442 1.83325 14.7442 1.83325 13.2442V11.4442C1.83325 9.94424 2.43325 9.34424 3.93325 9.34424H5.73325C7.23325 9.34424 7.83325 9.94424 7.83325 11.4442Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }

                                                onClick={() => {

                                                    if (!(authStore.isProAndGreater())) {
                                                        spaceStore.setBillingAccessModalOpen(true)
                                                    } else {
                                                        model.onEnlarge(src)
                                                    }
                                                }}
                                            >
                                                Enlarge
                                            </Menu.Item>

                                            <Menu.Item icon={
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14 6V2H10" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M2 10V14H6" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M14 2L9 7" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M7 9L2 14" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }

                                                onClick={() => {
                                                    if (!(authStore.isProAndGreater())) {
                                                        spaceStore.setBillingAccessModalOpen(true)
                                                    } else {
                                                        model.onUpscale(src, 'TOPAZ_ENHANCED')
                                                    }
                                                }}
                                            >
                                                Upscale with Topaz
                                            </Menu.Item>
                                            <Menu.Item icon={
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14 6V2H10" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M2 10V14H6" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M14 2L9 7" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M7 9L2 14" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }

                                                onClick={() => {
                                                    if (!(authStore.isBasicAndGreater())) {
                                                        spaceStore.setBillingAccessModalOpen(true)
                                                    } else {
                                                        model.onUpscale(src, 'FREEPIK')
                                                    }
                                                }}
                                            >
                                                Upscale with Magnific
                                            </Menu.Item>

                                            <Menu.Item
                                                icon={
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2.33346 13.6667C2.88679 14.22 3.78012 14.22 4.33346 13.6667L13.0001 5.00002C13.5535 4.44669 13.5535 3.55336 13.0001 3.00002C12.4468 2.44669 11.5535 2.44669 11.0001 3.00002L2.33346 11.6667C1.78012 12.22 1.78012 13.1134 2.33346 13.6667Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M12.0068 5.99335L10.0068 3.99335" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M5.6665 1.62665L6.6665 1.33331L6.37317 2.33331L6.6665 3.33331L5.6665 3.03998L4.6665 3.33331L4.95984 2.33331L4.6665 1.33331L5.6665 1.62665Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M3 5.62665L4 5.33331L3.70667 6.33331L4 7.33331L3 7.03998L2 7.33331L2.29333 6.33331L2 5.33331L3 5.62665Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M13 8.96002L14 8.66669L13.7067 9.66669L14 10.6667L13 10.3734L12 10.6667L12.2933 9.66669L12 8.66669L13 8.96002Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>

                                                }

                                                onClick={() => {
                                                    if (!(authStore.isProAndGreater())) {
                                                        spaceStore.setBillingAccessModalOpen(true)
                                                    } else {
                                                        model.onAiRetouch2(src)
                                                    }
                                                }}
                                            >
                                                AI-Retouch
                                            </Menu.Item>
                                            {
                                                model.secretModeEnabled && <Menu.Item
                                                    icon={
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M2.33346 13.6667C2.88679 14.22 3.78012 14.22 4.33346 13.6667L13.0001 5.00002C13.5535 4.44669 13.5535 3.55336 13.0001 3.00002C12.4468 2.44669 11.5535 2.44669 11.0001 3.00002L2.33346 11.6667C1.78012 12.22 1.78012 13.1134 2.33346 13.6667Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M12.0068 5.99335L10.0068 3.99335" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M5.6665 1.62665L6.6665 1.33331L6.37317 2.33331L6.6665 3.33331L5.6665 3.03998L4.6665 3.33331L4.95984 2.33331L4.6665 1.33331L5.6665 1.62665Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M3 5.62665L4 5.33331L3.70667 6.33331L4 7.33331L3 7.03998L2 7.33331L2.29333 6.33331L2 5.33331L3 5.62665Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M13 8.96002L14 8.66669L13.7067 9.66669L14 10.6667L13 10.3734L12 10.6667L12.2933 9.66669L12 8.66669L13 8.96002Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>

                                                    }

                                                    onClick={() => {
                                                        if (!(authStore.isProAndGreater())) {
                                                            spaceStore.setBillingAccessModalOpen(true)
                                                        } else {
                                                            model.onCameraRotate(src)
                                                        }
                                                    }}
                                                >
                                                    [beta] Camera Rotate
                                                </Menu.Item>
                                            }



                                            {
                                                additionalSrc?.map((src) => {
                                                    if (src.type === 'changeBackground') {
                                                        return <Menu.Item
                                                            icon={
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M10.3398 1.88666H5.65984C3.99984 1.88666 3.63317 2.71332 3.41984 3.72666L2.6665 7.33332H13.3332L12.5798 3.72666C12.3665 2.71332 11.9998 1.88666 10.3398 1.88666Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M14.6598 13.2133C14.7332 13.9933 14.1065 14.6666 13.3065 14.6666H12.0532C11.3332 14.6666 11.2332 14.36 11.1065 13.98L10.9732 13.58C10.7865 13.0333 10.6665 12.6666 9.70649 12.6666H6.29316C5.33316 12.6666 5.19316 13.08 5.02649 13.58L4.89316 13.98C4.76649 14.36 4.66649 14.6666 3.94649 14.6666H2.69316C1.89316 14.6666 1.26649 13.9933 1.33982 13.2133L1.71316 9.15331C1.80649 8.15331 1.99982 7.33331 3.74649 7.33331H12.2532C13.9998 7.33331 14.1932 8.15331 14.2865 9.15331L14.6598 13.2133Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M2.66667 5.33331H2" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M14.0002 5.33331H13.3335" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M8 2V3.33333" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M7 3.33331H9" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M4 10H6" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M10 10H12" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            }

                                                            onClick={() => {
                                                                if (!(authStore.isProAndGreater())) {
                                                                    spaceStore.setBillingAccessModalOpen(true)
                                                                } else {
                                                                    model.changeBackground(src.src)
                                                                }
                                                            }}
                                                        >
                                                            Change Background
                                                        </Menu.Item>
                                                    } else {
                                                        return null
                                                    }
                                                })
                                            }





                                            {/* <Menu.Item
                                                icon={
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.5867 6.92002V9.07334C11.5867 10.8667 10.8667 11.5867 9.0734 11.5867H6.92007C5.12674 11.5867 4.40674 10.8667 4.40674 9.07334V6.92002C4.40674 5.12669 5.12674 4.40668 6.92007 4.40668H9.0734C10.8734 4.41334 11.5867 5.12669 11.5867 6.92002Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M14.6668 3.84664V5.99998C14.6668 7.79331 13.9468 8.51331 12.1535 8.51331H11.5868V6.92666C11.5868 5.13332 10.8668 4.41331 9.07348 4.41331H7.48682V3.84664C7.48682 2.05331 8.20682 1.33331 10.0002 1.33331H12.1535C13.9468 1.33331 14.6668 2.05331 14.6668 3.84664Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M1.3335 12.1534V10C1.3335 8.20669 2.0535 7.48669 3.84683 7.48669H4.4135V9.07334C4.4135 10.8667 5.1335 11.5867 6.92683 11.5867H8.5135V12.1534C8.5135 13.9467 7.7935 14.6667 6.00016 14.6667H3.84683C2.0535 14.6667 1.3335 13.9467 1.3335 12.1534Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>

                                                }
                                                onClick={() => {
                                                    if (!(authStore.isProAndGreater())) {
                                                        spaceStore.setBillingAccessModalOpen(true)
                                                    } else {
                                                        model.makeVariations(src)
                                                    }
                                                }}
                                            >
                                                Make variations
                                            </Menu.Item> */}
                                            {
                                                model.audiThMode && (
                                                    <>

                                                        <Menu.Item
                                                            icon={
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M10.3398 1.88666H5.65984C3.99984 1.88666 3.63317 2.71332 3.41984 3.72666L2.6665 7.33332H13.3332L12.5798 3.72666C12.3665 2.71332 11.9998 1.88666 10.3398 1.88666Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M14.6598 13.2133C14.7332 13.9933 14.1065 14.6666 13.3065 14.6666H12.0532C11.3332 14.6666 11.2332 14.36 11.1065 13.98L10.9732 13.58C10.7865 13.0333 10.6665 12.6666 9.70649 12.6666H6.29316C5.33316 12.6666 5.19316 13.08 5.02649 13.58L4.89316 13.98C4.76649 14.36 4.66649 14.6666 3.94649 14.6666H2.69316C1.89316 14.6666 1.26649 13.9933 1.33982 13.2133L1.71316 9.15331C1.80649 8.15331 1.99982 7.33331 3.74649 7.33331H12.2532C13.9998 7.33331 14.1932 8.15331 14.2865 9.15331L14.6598 13.2133Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M2.66667 5.33331H2" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M14.0002 5.33331H13.3335" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M8 2V3.33333" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M7 3.33331H9" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M4 10H6" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M10 10H12" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>

                                                            }
                                                            onClick={() => {
                                                                model.onFillCarObject(src)
                                                            }}
                                                        >
                                                            [beta] Add Car
                                                        </Menu.Item>
                                                    </>
                                                )
                                            }

                                        </Menu.Dropdown>
                                    </Menu>
                                )
                            }

                            {
                                types.includes('cgi') && (
                                    <Menu shadow="md">
                                        <Menu.Target>
                                            <Button

                                                color="orange"
                                                // p={8}
                                                size="xs"
                                                variant="filled"
                                                style={{ zIndex: 1, paddingLeft: 8, paddingRight: 8 }}
                                                styles={{
                                                    root: {
                                                        paddingLeft: 8,
                                                        paddingRight: 8
                                                    },
                                                    leftIcon: {
                                                        marginRight: 4
                                                    }
                                                }}
                                                leftIcon={
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4.99984 3.33331H10.9998C11.4132 3.33331 11.7798 3.34665 12.1065 3.39331C13.8598 3.58665 14.3332 4.41331 14.3332 6.66665V9.33331C14.3332 11.5866 13.8598 12.4133 12.1065 12.6066C11.7798 12.6533 11.4132 12.6666 10.9998 12.6666H4.99984C4.5865 12.6666 4.21984 12.6533 3.89317 12.6066C2.13984 12.4133 1.6665 11.5866 1.6665 9.33331V6.66665C1.6665 4.41331 2.13984 3.58665 3.89317 3.39331C4.21984 3.34665 4.5865 3.33331 4.99984 3.33331Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M3 1.33331H13" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M3.3335 14.6667H13.3335" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }


                                            >
                                                CGI tools
                                            </Button>
                                        </Menu.Target>
                                        <Menu.Dropdown>

                                            <Menu.Item
                                                icon={
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.3398 1.88666H5.65984C3.99984 1.88666 3.63317 2.71332 3.41984 3.72666L2.6665 7.33332H13.3332L12.5798 3.72666C12.3665 2.71332 11.9998 1.88666 10.3398 1.88666Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M14.6598 13.2133C14.7332 13.9933 14.1065 14.6666 13.3065 14.6666H12.0532C11.3332 14.6666 11.2332 14.36 11.1065 13.98L10.9732 13.58C10.7865 13.0333 10.6665 12.6666 9.70649 12.6666H6.29316C5.33316 12.6666 5.19316 13.08 5.02649 13.58L4.89316 13.98C4.76649 14.36 4.66649 14.6666 3.94649 14.6666H2.69316C1.89316 14.6666 1.26649 13.9933 1.33982 13.2133L1.71316 9.15331C1.80649 8.15331 1.99982 7.33331 3.74649 7.33331H12.2532C13.9998 7.33331 14.1932 8.15331 14.2865 9.15331L14.6598 13.2133Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M2.66667 5.33331H2" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M14.0002 5.33331H13.3335" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M8 2V3.33333" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M7 3.33331H9" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M4 10H6" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M10 10H12" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }
                                                onClick={() => {
                                                    if (!(authStore.isBasicAndGreater())) {
                                                        spaceStore.setBillingAccessModalOpen(true)
                                                    } else {
                                                        model.onRemoveObject(src)
                                                    }
                                                }}
                                            >
                                                Remove Car
                                            </Menu.Item>

                                            <Menu.Item
                                                icon={
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4.99984 3.33331H10.9998C11.4132 3.33331 11.7798 3.34665 12.1065 3.39331C13.8598 3.58665 14.3332 4.41331 14.3332 6.66665V9.33331C14.3332 11.5866 13.8598 12.4133 12.1065 12.6066C11.7798 12.6533 11.4132 12.6666 10.9998 12.6666H4.99984C4.5865 12.6666 4.21984 12.6533 3.89317 12.6066C2.13984 12.4133 1.6665 11.5866 1.6665 9.33331V6.66665C1.6665 4.41331 2.13984 3.58665 3.89317 3.39331C4.21984 3.34665 4.5865 3.33331 4.99984 3.33331Z" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M3 1.33331H13" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M3.3335 14.6667H13.3335" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }
                                                onClick={() => {
                                                    if (!(authStore.isBasicAndGreater())) {
                                                        spaceStore.setBillingAccessModalOpen(true)
                                                    } else {
                                                        model.createHDR(src)
                                                    }
                                                }}
                                            >
                                                Generate 360°HDR
                                            </Menu.Item>
                                            <Menu.Item
                                                icon={
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7.14206 13.2949C10.4421 13.2949 13.1174 10.6196 13.1174 7.31955C13.1174 4.01947 10.4421 1.34424 7.14206 1.34424C3.84198 1.34424 1.16675 4.01947 1.16675 7.31955C1.16675 10.6196 3.84198 13.2949 7.14206 13.2949Z" stroke="#BDBDBD" />
                                                        <path d="M11.4878 11.6652L15.8335 16.0108" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }
                                                onClick={() => {
                                                    model.searchInHdrMaground(src)
                                                }}
                                            >
                                                Find photographed HDR-Dome
                                            </Menu.Item>

                                        </Menu.Dropdown>
                                    </Menu>
                                )
                            }


                        </Flex>
                        {
                            types.includes('animate') && (<Menu shadow="md">
                                <Menu.Target>
                                    <Button

                                        color="orange"
                                        // p={8}
                                        size="xs"
                                        variant="filled"
                                        styles={{
                                            root: {
                                                paddingLeft: 8,
                                                paddingRight: 8
                                            },
                                            leftIcon: {
                                                marginRight: 4
                                            }
                                        }}
                                        style={{ zIndex: 1, paddingLeft: 8, paddingRight: 8 }}
                                        leftIcon={
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8 5V19L19 12L8 5Z" fill="#ffffff" />
                                            </svg>
                                        }
                                    >
                                        Animate
                                    </Button>
                                </Menu.Target>
                                <Menu.Dropdown>
                                    <Menu.Item
                                        icon={
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.09998 12V10.52C9.09998 8.60999 10.45 7.83999 12.1 8.78999L13.38 9.52999L14.66 10.27C16.31 11.22 16.31 12.78 14.66 13.73L13.38 14.47L12.1 15.21C10.45 16.16 9.09998 15.38 9.09998 13.48V12Z" stroke="#BDBDBD" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        }
                                        onClick={() => {
                                            if (!(authStore.isProAndGreater())) {
                                                spaceStore.setBillingAccessModalOpen(true)
                                            } else {
                                                model.onCreateImageKling(src)
                                            }
                                        }}
                                    >
                                        Animate with KLING 2.5 [PRO]
                                    </Menu.Item>

                                    <Menu.Item
                                        icon={
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.09998 12V10.52C9.09998 8.60999 10.45 7.83999 12.1 8.78999L13.38 9.52999L14.66 10.27C16.31 11.22 16.31 12.78 14.66 13.73L13.38 14.47L12.1 15.21C10.45 16.16 9.09998 15.38 9.09998 13.48V12Z" stroke="#BDBDBD" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        }
                                        onClick={() => {
                                            if (!(authStore.isBasicAndGreater())) {
                                                spaceStore.setBillingAccessModalOpen(true)
                                            } else {
                                                model.onCreateImageVeo(src)
                                            }
                                        }}
                                    >
                                        Animate with VEO 3.0
                                    </Menu.Item>

                                    <Menu.Item
                                        icon={
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.09998 12V10.52C9.09998 8.60999 10.45 7.83999 12.1 8.78999L13.38 9.52999L14.66 10.27C16.31 11.22 16.31 12.78 14.66 13.73L13.38 14.47L12.1 15.21C10.45 16.16 9.09998 15.38 9.09998 13.48V12Z" stroke="#BDBDBD" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        }
                                        onClick={() => {
                                            if (!(authStore.isProAndGreater())) {
                                                spaceStore.setBillingAccessModalOpen(true)
                                            } else {
                                                model.onCreateImageHailuo(src)
                                            }
                                        }}
                                    >
                                        Animate with Hailuo Minimax
                                    </Menu.Item>

                                    <Menu.Item
                                        icon={
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.09998 12V10.52C9.09998 8.60999 10.45 7.83999 12.1 8.78999L13.38 9.52999L14.66 10.27C16.31 11.22 16.31 12.78 14.66 13.73L13.38 14.47L12.1 15.21C10.45 16.16 9.09998 15.38 9.09998 13.48V12Z" stroke="#BDBDBD" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        }
                                        onClick={() => {
                                            if (!(authStore.isProAndGreater())) {
                                                spaceStore.setBillingAccessModalOpen(true)
                                            } else {
                                                model.onCreateImageSeedance(src)
                                            }
                                        }}
                                    >
                                        Animate with Seedance PRO
                                    </Menu.Item>
                                    <Menu.Item
                                        icon={
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.09998 12V10.52C9.09998 8.60999 10.45 7.83999 12.1 8.78999L13.38 9.52999L14.66 10.27C16.31 11.22 16.31 12.78 14.66 13.73L13.38 14.47L12.1 15.21C10.45 16.16 9.09998 15.38 9.09998 13.48V12Z" stroke="#BDBDBD" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        }
                                        onClick={() => {
                                            if (!(authStore.isProAndGreater())) {
                                                spaceStore.setBillingAccessModalOpen(true)
                                            } else {
                                                model.onCreateImageWan(src)
                                            }
                                        }}
                                    >
                                        Animate with Wan 2.5
                                    </Menu.Item>

                                </Menu.Dropdown>
                            </Menu>)
                        }


                    </Flex>
                </Flex>
            </>
        )

    }
    if (model.pipeline.rating === -1) {
        return null
    }
    const pipelineRating = model.pipeline.rating || 0

    if (pipelineRating) {

        console.log('pipelineRating', pipelineRating)
    }

    if ((model.rating !== 0 && pipelineRating === 0) || (model.rating !== 0 && pipelineRating !== model.rating)) {
        return <Text fz={10} opacity={0.2}>Generation {model.pipeline.jobId} is hidden</Text>
    }

    console.log(model.pipeline.jobId === '-vFMEstId1VQTEQRxliya' ? JSON.stringify(model.pipeline) : '')
    return (
        <Flex
            pb={30}
            pt={30}
            style={{ borderRadius: '8px', overflow: 'scroll' }}
            bg={'rgba(32, 32, 32, 1)'}
            pl={'1.8rem'}
            pr={'1.8rem'}
            direction={'column'}
            w={'100%'}
            miw={'100%'}>
            {
                model.pipeline.status === 'pending' || model.pipeline.status === 'ending' ?
                    <Flex h="468px" align={'center'}>
                        <Flex gap={12} direction={'column'}>
                            <Text>Generation {model.pipeline.jobId} is running </Text>
                            <Progress style={{ width: '300px' }} radius="lg" size="lg" color="#f53c02" value={100} striped animate={true} w={'100%'} />
                        </Flex>
                    </Flex> : null
            }
            {
                model.pipeline.status === 'failed' ?
                    <Flex pt={20} pb={0} align={'center'}>
                        <Flex gap={12} direction={'column'}>
                            <Text>Generation {model.pipeline.jobId} failed to run. Credits for this generation will be refunded. </Text>
                        </Flex>
                    </Flex> : null
            }
            {
                model.pipeline.status === 'completed' ? (
                    <Flex direction={'column'}>
                        {
                            model.pipeline.params.type === 'customModelV1' ? (
                                <>
                                    <Flex align={'center'} gap={12} mb={6}>
                                        <Text fz={20} >GENERATION: {model.pipeline.jobId} </Text>
                                        <Badge
                                            style={{
                                                color: "#e0e0e0"
                                            }}
                                            size="lg"
                                            radius="sm"
                                            bg="#464646"
                                        >Custom Model {model.pipeline.params.modelName}</Badge>
                                    </Flex>

                                    <Flex>

                                        <Flex direction={'column'} miw={'300px'} w={'300px'} mr={20} gap={6}>
                                            {
                                                model.pipeline.params.prompt ? <Spoiler maxHeight={120} showLabel="Show more" hideLabel="Hide">
                                                    <Text fz={12} style={{ color: 'BDBDBD' }}>Prompt:</Text>
                                                    <Text fz={12} >
                                                        {model.pipeline.params.prompt}
                                                    </Text>

                                                </Spoiler> : null
                                            }


                                            {
                                                model.pipeline.params.modelVersion && (
                                                    <Button
                                                        variant="default"
                                                        size={'xs'}
                                                        onClick={async () => {
                                                            model.openCustomModelVersion(model.pipeline.params.modelVersion, model.pipeline.params.prompt, model.pipeline.params.aspectRation)
                                                        }}
                                                    >
                                                        Generate from this model
                                                    </Button>
                                                )
                                            }

                                            {/* <RateComponent
                                                generationId={model.pipeline.jobId}
                                                srcImage={model.pipeline.params.srcset[0]}
                                            /> */}

                                            <Rating
                                                mt={20}
                                                value={model.pipeline.rating || 0}
                                                styles={{
                                                    root: { cursor: 'pointer' },
                                                    symbolBody: { cursor: 'pointer' }
                                                }}
                                                color={'#f53c02'}
                                                onChange={(value) => {
                                                    model.onUpdateRating(value)
                                                }}
                                            />
                                            <Button
                                                mt={6}
                                                w={'auto'}
                                                title='Rate this generation'
                                                size={'xs'}
                                                variant="default"
                                                onClick={() => {
                                                    model.onUpdateRating(-1)
                                                }}
                                            >

                                                <Text>Archive generation</Text>
                                            </Button>

                                            <Text fz={12} style={{ color: 'BDBDBD' }}>Credits spent: {model.pipeline.params.credits}</Text>
                                            {
                                                model.secretModeEnabled && (
                                                    <Text fz={10} color="red" onClick={() => {
                                                        model.addFeatured(model.pipeline.jobId)
                                                    }}>[beta] Add to featured </Text>
                                                )
                                            }
                                        </Flex>
                                        <Flex
                                            gap={20}
                                            direction={model.big ? "column" : undefined}
                                            w={model.big ? '100%' : undefined}
                                        >
                                            {(model.pipeline.params.srcset).map((src, index) => {
                                                return (
                                                    <Flex direction={'column'} pos={'relative'} bg={'rgba(16, 16, 16, 1)'} justify={'center'} onMouseEnter={() => setHoveredSrc(src)} onMouseLeave={() => setHoveredSrc(null)}>
                                                        {renderMenu(src, ['car', 'edit', 'animate', 'cgi'], hoveredSrc === src)}
                                                        <ImageObserved
                                                            width={model.big ? '100%' : bigImage}
                                                            height={model.big ? '100%' : bigImage}
                                                            dark={true}
                                                            src={model.pipeline.params.srcsetPreview ? model.pipeline.params.srcsetPreview[index] : src} />
                                                    </Flex>
                                                );
                                            })}
                                        </Flex>
                                    </Flex>
                                </>
                            ) : null
                        }
                        {
                            model.pipeline.params.type === 'img2img' || model.pipeline.params.type === 'gen360' || model.pipeline.params.type === 'removeObject' || model.pipeline.params.type === 'removeObject2' || model.pipeline.params.type === 'fillCar' || model.pipeline.params.type === 'fixRims' || model.pipeline.params.type === 'img2imgflux' || model.pipeline.params.type === 'fluxControlnet' || model.pipeline.params.type === 'customModel360V1' || model.pipeline.params.type === 'customModelV2' || model.pipeline.params.type === 'controlV1' || model.pipeline.params.type === 'controlV2' || model.pipeline.params.type === 'controlV3' || model.pipeline.params.type === 'fixWhiteBalance' || model.pipeline.params.type === 'placeCarV2' || model.pipeline.params.type === 'img2imgfluxv2' || model.pipeline.params.type === 'placeCarImageV3' || model.pipeline.params.type === 'panorama360' || model.pipeline.params.type === 'placeCarImageV4' || model.pipeline.params.type === 'applyMood' || model.pipeline.params.type === 'placeCarCustom' || model.pipeline.params.type === 'placeCarK' || model.pipeline.params.type === 'nanoBanana' || model.pipeline.params.type === 'nanoBananaMultiple' || model.pipeline.params.type === 'nanoBananaPlaceCar2'
                                || model.pipeline.params.type === 'cameraRotateV1' ? (
                                <>
                                    <Flex align={'center'} gap={12} mb={6}>
                                        <Text fz={20} >GENERATION: {model.pipeline.jobId} </Text>
                                        <Badge
                                            style={{
                                                color: "#e0e0e0"
                                            }}
                                            size="lg"
                                            radius="sm"
                                            bg="#464646"
                                        >Generation</Badge>
                                    </Flex>

                                    <Flex>

                                        <Flex direction={'column'} miw={'300px'} w={'300px'} mr={20} gap={6}>
                                            <Flex direction={'column'} gap={8}>
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Reference image:</Text>
                                                <ImageObserved
                                                    dark
                                                    width={image}
                                                    height={image}
                                                    src={model.pipeline.params.inputSrcPreview ?? model.pipeline.params.inputSrc}
                                                />
                                            </Flex>
                                            {
                                                model.pipeline.params.prompt ? <Spoiler maxHeight={120} showLabel="Show more" hideLabel="Hide">
                                                    {
                                                        model.pipeline.params.cameraInfo ? model.pipeline.params.cameraInfo.map((camera) => (<>
                                                            <Flex gap={6}>
                                                                <Text fz={12} style={{ color: 'BDBDBD', fontWeight: 700 }}>{camera.key}:</Text> <Text fz={10} >
                                                                    {camera.value}
                                                                </Text>
                                                            </Flex>
                                                        </>)) : null
                                                    }
                                                    <Text fz={12} style={{ color: 'BDBDBD' }}>Prompt:</Text>
                                                    <Text fz={12} >
                                                        {model.pipeline.params.prompt}
                                                    </Text>


                                                </Spoiler> : null
                                            }

                                            {
                                                model.pipeline.params.type === 'nanoBanana' || model.pipeline.params.type === 'nanoBananaMultiple' || model.pipeline.params.type === 'nanoBananaPlaceCar2' ? <Text fz={12} style={{ color: 'BDBDBD' }}>Type: Nano Banana</Text> : null
                                            }
                                            {
                                                (model.pipeline.params.type === 'controlV2' || model.pipeline.params.type === 'controlV3') && model.pipeline.params.cameraCode ? <Text fz={12} style={{ color: 'BDBDBD' }}>Camera Code: {model.pipeline.params.cameraCode}</Text> : null
                                            }
                                            {
                                                model.pipeline.params.type === 'placeCarK' ? <Text fz={12} style={{ color: 'BDBDBD' }}>Type: Kontext</Text> : null
                                            }


                                            {
                                                model.pipeline.params.negativePrompt ?
                                                    <Spoiler maxHeight={120} showLabel="Show more" hideLabel="Hide">
                                                        <Text fz={12} style={{ color: 'BDBDBD' }}>Negative prompt:</Text>
                                                        <Text fz={12} >
                                                            {model.pipeline.params.negativePrompt}
                                                        </Text>
                                                    </Spoiler> : null
                                            }





                                            {/* <RateComponent
                                                generationId={model.pipeline.jobId}
                                                srcImage={model.pipeline.params.srcset[0]}
                                            /> */}

                                            <Rating
                                                mt={20}
                                                value={model.pipeline.rating || 0}
                                                styles={{
                                                    root: { cursor: 'pointer' },
                                                    symbolBody: { cursor: 'pointer' }
                                                }}
                                                color={'#f53c02'}
                                                onChange={(value) => {
                                                    model.onUpdateRating(value)
                                                }}
                                            />
                                            <Button
                                                mt={6}
                                                w={'auto'}
                                                title='Rate this generation'
                                                size={'xs'}
                                                variant="default"
                                                onClick={() => {
                                                    model.onUpdateRating(-1)
                                                }}
                                            >

                                                <Text>Archive generation</Text>
                                            </Button>


                                            <Text fz={12} style={{ color: 'BDBDBD' }}>Credits spent: {model.pipeline.params.credits}</Text>
                                            {
                                                model.secretModeEnabled && (
                                                    <Text fz={10} color="red" onClick={() => {
                                                        model.addFeatured(model.pipeline.jobId)
                                                    }}>[beta] Add to featured </Text>
                                                )
                                            }
                                        </Flex>
                                        <Flex
                                            gap={20}
                                            direction={model.big ? "column" : undefined}
                                            w={model.big ? '100%' : undefined}
                                        >
                                            {(model.pipeline.params.srcset).map((src, index) => (
                                                <Flex direction={'column'} pos={'relative'} bg={'rgba(16, 16, 16, 1)'} justify={'center'} onMouseEnter={() => setHoveredSrc(src)} onMouseLeave={() => setHoveredSrc(null)}>
                                                    {renderMenu(src,
                                                        ['car', 'edit', 'animate', 'cgi'],
                                                        hoveredSrc === src,
                                                        model.pipeline.params.type === 'nanoBananaPlaceCar2' ? [
                                                            {
                                                                type: 'changeBackground',
                                                                src: model.pipeline.params.carSrc,
                                                            }
                                                        ] : undefined)
                                                    }

                                                    <ImageObserved
                                                        width={model.big ? '100%' : bigImage}
                                                        height={model.big ? '100%' : bigImage}
                                                        dark={true}
                                                        src={model.pipeline.params.srcsetPreview ? model.pipeline.params.srcsetPreview[index] : src}
                                                    />
                                                </Flex>
                                            ))}
                                        </Flex>
                                    </Flex>
                                </>
                            ) : null
                        }
                        {
                            model.pipeline.params.type === 'kling' || model.pipeline.params.type === 'wan'
                                || model.pipeline.params.type === 'hailuo' || model.pipeline.params.type === 'veo' || model.pipeline.params.type === 'seedance' ? (
                                <>
                                    <Flex align={'center'} gap={12} mb={6}>
                                        <Text fz={20} >GENERATION: {model.pipeline.jobId} </Text>
                                        <Badge
                                            style={{
                                                color: "#e0e0e0"
                                            }}
                                            size="lg"
                                            radius="sm"
                                            bg="#464646"
                                        >Generation</Badge>
                                    </Flex>

                                    <Flex>

                                        <Flex direction={'column'} miw={'300px'} w={'300px'} mr={20} gap={6}>
                                            <Flex direction={'column'} gap={8}>
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Reference image:</Text>
                                                <ImageObserved
                                                    dark
                                                    width={image}
                                                    height={image}
                                                    src={model.pipeline.params.inputSrcPreview ?? model.pipeline.params.inputSrc}
                                                />
                                            </Flex>
                                            {
                                                model.pipeline.params.prompt ? <Spoiler maxHeight={120} showLabel="Show more" hideLabel="Hide">
                                                    <Text fz={12} style={{ color: 'BDBDBD' }}>Prompt:</Text>
                                                    <Text fz={12} >
                                                        {model.pipeline.params.prompt}
                                                    </Text>

                                                </Spoiler> : null
                                            }

                                            <Flex direction={'column'} gap={8}>
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Provider: {model.pipeline.params.type.toUpperCase()}</Text>
                                            </Flex>

                                            <Rating
                                                mt={20}
                                                value={model.pipeline.rating || 0}
                                                styles={{
                                                    root: { cursor: 'pointer' },
                                                    symbolBody: { cursor: 'pointer' }
                                                }}
                                                color={'#f53c02'}
                                                onChange={(value) => {
                                                    model.onUpdateRating(value)
                                                }}
                                            />
                                            <Button
                                                mt={6}
                                                w={'auto'}
                                                title='Rate this generation'
                                                size={'xs'}
                                                variant="default"
                                                onClick={() => {
                                                    model.onUpdateRating(-1)
                                                }}
                                            >

                                                <Text>Archive generation</Text>
                                            </Button>


                                            <Text fz={12} style={{ color: 'BDBDBD' }}>Credits spent: {model.pipeline.params.credits}</Text>
                                        </Flex>
                                        <Flex
                                            gap={20}
                                            direction={model.big ? "column" : undefined}
                                            w={model.big ? '100%' : undefined}
                                        >
                                            {(model.pipeline.params.srcset).map((src, index) => (
                                                <Flex direction={'column'} pos={'relative'} bg={'rgba(16, 16, 16, 1)'} justify={'center'} onMouseEnter={() => setHoveredSrc(src)} onMouseLeave={() => setHoveredSrc(null)}>
                                                    {renderMenu(src, [], hoveredSrc === src)}
                                                    <video
                                                        width={model.big ? '100%' : bigImage}
                                                        height={model.big ? '100%' : bigImage}
                                                        controls
                                                        style={{
                                                            backgroundColor: 'black',
                                                            borderRadius: '4px'
                                                        }}
                                                    >
                                                        <source src={src} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                </Flex>
                                            ))}
                                        </Flex>
                                    </Flex>
                                </>
                            ) : null
                        }
                        {
                            model.pipeline.params.type === 'customModel360HDRV2' || model.pipeline.params.type === 'customModel360HDRV3' ? (
                                <>
                                    <Flex align={'center'} gap={12} mb={6}>
                                        <Text fz={20}>GENERATION: {model.pipeline.jobId} </Text>
                                        <Badge
                                            style={{
                                                color: "#e0e0e0"
                                            }}
                                            size="lg"
                                            radius="sm"
                                            bg="#464646"
                                        >HDRI</Badge>
                                    </Flex>

                                    <Flex>

                                        <Flex direction={'column'} miw={'300px'} w={'300px'} mr={20} gap={6}>
                                            <Spoiler maxHeight={120} showLabel="Show more" hideLabel="Hide">
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Prompt:</Text>
                                                <Text fz={12} >
                                                    {model.pipeline.params.prompt}
                                                </Text>

                                            </Spoiler>
                                            {/* <RateComponent
                                                generationId={model.pipeline.jobId}
                                                srcImage={model.pipeline.params.srcset[0]}
                                            /> */}

                                            <Text fz={12} style={{ color: 'BDBDBD' }}>Credits spent: {model.pipeline.params.credits}</Text>
                                        </Flex>
                                        <Flex
                                            gap={20}
                                            direction={model.big ? "column" : undefined}
                                            w={model.big ? '100%' : undefined}
                                        >
                                            {(model.pipeline.params.srcset).map((src, index) => (
                                                <Flex direction={'column'} key={src}>
                                                    <Flex
                                                        p={"xs"}
                                                        bg={"rgba(16, 16, 16, 1)"}
                                                        align={'center'}
                                                        justify={'center'}
                                                        h={'400px'}

                                                        style={{
                                                            borderRadius: '4px'
                                                        }}
                                                        gap={12}
                                                        w="400px"
                                                    // w="max-content"
                                                    >
                                                        <Text>HDRi ready</Text>
                                                        {' '}
                                                        <Button

                                                            color="orange"
                                                            size="xs"
                                                            variant="filled"
                                                            style={{ zIndex: 1, paddingLeft: 8, paddingRight: 8, opacity: show ? 1 : 0, pointerEvents: show ? 'auto' : 'none', transition: 'opacity 150ms ease-in-out' }}
                                                            styles={{
                                                                root: {
                                                                    paddingLeft: 8,
                                                                    paddingRight: 8
                                                                },
                                                                leftIcon: {
                                                                    marginRight: 4
                                                                }
                                                            }}
                                                            leftIcon={
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M6 7.33325V11.3333L7.33333 9.99992" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M6.00033 11.3333L4.66699 10" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M14.6663 6.66659V9.99992C14.6663 13.3333 13.333 14.6666 9.99967 14.6666H5.99967C2.66634 14.6666 1.33301 13.3333 1.33301 9.99992V5.99992C1.33301 2.66659 2.66634 1.33325 5.99967 1.33325H9.33301" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M14.6663 6.66658H11.9997C9.99967 6.66658 9.33301 5.99992 9.33301 3.99992V1.33325L14.6663 6.66658Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            }



                                                            component={"a"}
                                                            href={src}
                                                            target={"_blank"}
                                                            download='test.hdr'

                                                        >
                                                            Download EXR
                                                        </Button>
                                                    </Flex>

                                                </Flex>
                                            ))}
                                        </Flex>
                                    </Flex>
                                </>
                            ) : null
                        }
                        {
                            model.pipeline.params.type === 'changeBackground2' || model.pipeline.params.type === 'changeBackground3' ? (
                                <>
                                    <Flex align={'center'} gap={12} mb={6}>
                                        <Text fz={20} >GENERATION: {model.pipeline.jobId} </Text>
                                        <Badge
                                            style={{
                                                color: "#e0e0e0"
                                            }}
                                            size="lg"
                                            radius="sm"
                                            bg="#464646"
                                        >Generation</Badge>
                                    </Flex>

                                    <Flex>

                                        <Flex direction={'column'} miw={'300px'} w={'300px'} mr={20} gap={6}>
                                            <Flex direction={'column'} gap={8}>
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Reference image:</Text>
                                                <ImageObserved
                                                    dark
                                                    width={image}
                                                    height={image}
                                                    src={model.pipeline.params.inputSrcPreview ?? model.pipeline.params.inputSrc}
                                                />
                                            </Flex>
                                            <Flex direction={'column'} gap={8}>
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Background image:</Text>
                                                <ImageObserved
                                                    dark
                                                    width={image}
                                                    height={image}
                                                    src={model.pipeline.params.backgroundSrc}
                                                />
                                            </Flex>
                                            <Spoiler maxHeight={120} showLabel="Show more" hideLabel="Hide">
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Prompt:</Text>
                                                <Text fz={12} >
                                                    {model.pipeline.params.prompt}
                                                </Text>

                                            </Spoiler>

                                            <Spoiler maxHeight={120} showLabel="Show more" hideLabel="Hide">
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Negative prompt:</Text>
                                                <Text fz={12} >
                                                    {model.pipeline.params.negativePrompt}
                                                </Text>
                                            </Spoiler>

                                            {/* <RateComponent
                                                generationId={model.pipeline.jobId}
                                                srcImage={model.pipeline.params.srcset[0]}
                                            /> */}

                                            <Text fz={12} style={{ color: 'BDBDBD' }}>Credits spent: {model.pipeline.params.credits}</Text>

                                        </Flex>
                                        <Flex gap={20}
                                            direction={model.big ? "column" : undefined}
                                            w={model.big ? '100%' : undefined}
                                        >
                                            {model.pipeline.params.srcset.map((src, index) => (
                                                <Flex direction={'column'} pos={'relative'} bg={'rgba(16, 16, 16, 1)'} justify={'center'} onMouseEnter={() => setHoveredSrc(src)} onMouseLeave={() => setHoveredSrc(null)}>
                                                    {renderMenu(src, ['car', 'edit', 'animate', 'cgi'], hoveredSrc === src)}
                                                    <ImageObserved
                                                        width={model.big ? '100%' : bigImage}
                                                        height={model.big ? '100%' : bigImage}
                                                        dark={true}
                                                        src={src}
                                                    />
                                                </Flex>
                                            ))}
                                        </Flex>
                                    </Flex>
                                </>
                            ) : null
                        }
                        {
                            model.pipeline.params.type === 'enlarge' ? (
                                <>
                                    <Flex align={'center'} gap={12} mb={6}>
                                        <Text fz={20} >GENERATION: {model.pipeline.jobId} </Text>
                                        <Badge
                                            style={{
                                                color: "#e0e0e0"
                                            }}
                                            size="lg"
                                            radius="sm"
                                            bg="#464646"
                                        >Enlarging</Badge>
                                    </Flex>

                                    <Flex>

                                        <Flex direction={'column'} w={'300px'} miw={'300px'} mr={20} gap={6}>
                                            <Flex direction={'column'} gap={8}>
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Reference image:</Text>
                                                <ImageObserved
                                                    dark
                                                    width={image}
                                                    height={image}
                                                    src={model.pipeline.params.inputSrcPreview ?? model.pipeline.params.inputSrc}
                                                />
                                            </Flex>

                                            {/* <RateComponent
                                                generationId={model.pipeline.jobId}
                                                srcImage={model.pipeline.params.outputSrc}
                                            /> */}

                                            <Text fz={12} style={{ color: 'BDBDBD' }}>Credits spent: {model.pipeline.params.credits}</Text>


                                        </Flex>
                                        <Flex gap={20}>

                                            <Flex direction={'column'} pos={'relative'} bg={'rgba(16, 16, 16, 1)'} justify={'center'} onMouseEnter={() => setHoveredSrc(model.pipeline.params.outputSrc)} onMouseLeave={() => setHoveredSrc(null)}>
                                                {renderMenu(model.pipeline.params.outputSrc, ['car', 'edit', 'animate', 'cgi'], hoveredSrc === model.pipeline.params.outputSrc)}
                                                <ImageObserved
                                                    width={model.big ? '100%' : bigImage}
                                                    height={model.big ? '100%' : bigImage}
                                                    dark={true}
                                                    src={model.pipeline.params.outputSrcPreview || model.pipeline.params.outputSrc}
                                                />
                                            </Flex>

                                        </Flex>
                                    </Flex>
                                </>
                            ) : null
                        }

                        {
                            model.pipeline.params.type === 'upscale' || model.pipeline.params.type === 'upscaleV1' || model.pipeline.params.type === 'upscaleV2' ? (
                                <>
                                    <Flex align={'center'} gap={12} mb={6}>
                                        <Text fz={20} >GENERATION: {model.pipeline.jobId} </Text>
                                        <Badge
                                            style={{
                                                color: "#e0e0e0"
                                            }}
                                            size="lg"
                                            radius="sm"
                                            bg="#464646"
                                        >Upscaling</Badge>
                                    </Flex>

                                    <Flex>
                                        <Flex direction={'column'} w={'300px'} miw={'300px'} mr={20} gap={6}>
                                            <Flex direction={'column'} gap={8}>
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Reference image:</Text>
                                                <ImageObserved
                                                    dark
                                                    width={image}
                                                    height={image}
                                                    src={model.pipeline.params.inputSrcPreview ?? model.pipeline.params.inputSrc}
                                                />
                                            </Flex>
                                            <Text fz={12} style={{ color: 'BDBDBD' }}>Type: {model.pipeline.params.type === 'upscaleV1' ? ('Topaz') : 'Magnific'}</Text>
                                            <Text fz={12} style={{ color: 'BDBDBD' }}>Scale: {(model.pipeline.params.type === 'upscaleV2' || model.pipeline.params.type === 'upscaleV1') && model.pipeline.params.provider === 'custom' ? (model.pipeline.params.upscaleType || model.pipeline.params.scaleFactor) : null}</Text>


                                            <Text fz={12} style={{ color: 'BDBDBD' }}>Credits spent: {model.pipeline.params.credits}</Text>
                                        </Flex>
                                        <Flex gap={20}>
                                            {!opened ? (
                                                <Flex direction={'column'} style={{ position: 'relative' }}>
                                                    <div style={{
                                                        filter: 'blur(5px)',
                                                        width: model.big ? '100%' : bigImage,
                                                        height: model.big ? '100%' : bigImage,
                                                        overflow: 'hidden'
                                                    }}>
                                                        <ImageObserved
                                                            width={model.big ? '100%' : bigImage}
                                                            height={model.big ? '100%' : bigImage}
                                                            dark={true}
                                                            src={model.pipeline.params.inputSrcPreview ?? model.pipeline.params.inputSrc}
                                                        />
                                                    </div>
                                                    <Button
                                                        style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            zIndex: 1,
                                                            backgroundColor: '#f53c02',
                                                            color: 'white'
                                                        }}
                                                        onClick={async () => {
                                                            if (model.pipeline.loadMore) {
                                                                await model.pipeline.loadMore()
                                                            }
                                                            setOpened(true)
                                                        }}
                                                    >
                                                        Load file
                                                    </Button>
                                                </Flex>
                                            ) : (
                                                model.pipeline.params.outputSrc ? (
                                                    <Flex direction={'column'} pos={'relative'} bg={'rgba(16, 16, 16, 1)'} justify={'center'} onMouseEnter={() => setHoveredSrc(model.pipeline.params.outputSrc)} onMouseLeave={() => setHoveredSrc(null)}>
                                                        {renderMenu(model.pipeline.params.outputSrc, ['edit', 'animate', 'cgi'], hoveredSrc === model.pipeline.params.outputSrc)}
                                                        <ImageObserved
                                                            width={model.big ? '100%' : bigImage}
                                                            height={model.big ? '100%' : bigImage}
                                                            dark={true}
                                                            src={model.pipeline.params.outputSrc}
                                                        />
                                                    </Flex>
                                                ) : (
                                                    <Flex
                                                        gap={20}
                                                        direction={model.big ? "column" : undefined}
                                                        w={model.big ? '100%' : undefined}
                                                    >
                                                        {model.pipeline.params.srcset.map((src, index) => (
                                                            <Flex direction={'column'} key={index} pos={'relative'} bg={'rgba(16, 16, 16, 1)'} justify={'center'} onMouseEnter={() => setHoveredSrc(src)} onMouseLeave={() => setHoveredSrc(null)}>
                                                                {renderMenu(src, ['edit', 'animate', 'cgi'], hoveredSrc === src)}
                                                                <ImageObserved
                                                                    width={model.big ? '100%' : bigImage}
                                                                    height={model.big ? '100%' : bigImage}
                                                                    dark={true}
                                                                    src={src}
                                                                />
                                                            </Flex>
                                                        ))}
                                                    </Flex>
                                                )
                                            )}
                                        </Flex>
                                    </Flex>
                                </>
                            ) : null
                        }
                        {
                            model.pipeline.params.type === 'genHDR' || model.pipeline.params.type === 'genHDR2' ? (
                                <>
                                    <Flex align={'center'} gap={12} mb={6}>
                                        <Text fz={20} >GENERATION: {model.pipeline.jobId} </Text>
                                        <Badge
                                            style={{
                                                color: "#e0e0e0"
                                            }}
                                            size="lg"
                                            radius="sm"
                                            bg="#464646"
                                        >HDR</Badge>
                                    </Flex>

                                    <Flex>
                                        <Flex direction={'column'} w={'300px'} miw={'300px'} mr={20} gap={6}>
                                            <Flex direction={'column'} gap={8}>
                                                <Text fz={12} style={{ color: 'BDBDBD' }}>Reference image:</Text>
                                                <ImageObserved
                                                    dark
                                                    width={image}
                                                    height={image}
                                                    src={model.pipeline.params.inputSrcPreview ?? model.pipeline.params.inputSrc}
                                                />
                                            </Flex>


                                            <Text fz={12} style={{ color: 'BDBDBD' }}>Credits spent: {model.pipeline.params.credits}</Text>
                                        </Flex>
                                        <Flex gap={20} style={{ position: 'relative' }}>
                                            <div style={{
                                                filter: 'blur(10px)',
                                                width: model.big ? '100%' : bigImage,
                                                height: model.big ? '100%' : bigImage,
                                                overflow: 'hidden'
                                            }}>
                                                <ImageObserved
                                                    width={model.big ? '100%' : bigImage}
                                                    height={model.big ? '100%' : bigImage}
                                                    dark={true}
                                                    src={model.pipeline.params.inputSrcPreview ?? model.pipeline.params.inputSrc}
                                                />
                                            </div>
                                            <Button
                                                component={"a"}
                                                href={model.pipeline.params.srcset[0]}
                                                target={"_blank"}
                                                download='test.png'
                                                style={{
                                                    position: 'absolute',
                                                    top: '45%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    zIndex: 1,
                                                    backgroundColor: '#f53c02',
                                                    color: 'white',
                                                    paddingLeft: 8, paddingRight: 8,
                                                }}

                                                color="orange"
                                                size="xs"
                                                variant="filled"
                                                // style={{ zIndex: 1, paddingLeft: 8, paddingRight: 8, opacity: show ? 1 : 0, pointerEvents: show ? 'auto' : 'none', transition: 'opacity 150ms ease-in-out' }}
                                                styles={{
                                                    root: {
                                                        paddingLeft: 8,
                                                        paddingRight: 8
                                                    },
                                                    leftIcon: {
                                                        marginRight: 4
                                                    }
                                                }}
                                                leftIcon={
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6 7.33325V11.3333L7.33333 9.99992" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M6.00033 11.3333L4.66699 10" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M14.6663 6.66659V9.99992C14.6663 13.3333 13.333 14.6666 9.99967 14.6666H5.99967C2.66634 14.6666 1.33301 13.3333 1.33301 9.99992V5.99992C1.33301 2.66659 2.66634 1.33325 5.99967 1.33325H9.33301" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M14.6663 6.66658H11.9997C9.99967 6.66658 9.33301 5.99992 9.33301 3.99992V1.33325L14.6663 6.66658Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }
                                            >
                                                Download HDR file
                                            </Button>
                                            {model.pipeline.params.outputPanorama ? <Button
                                                component={"a"}
                                                href={model.pipeline.params.outputPanorama}
                                                target={"_blank"}
                                                download='test.png'
                                                style={{
                                                    position: 'absolute',
                                                    top: '55%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    zIndex: 1,
                                                    backgroundColor: '#f53c02',
                                                    color: 'white',
                                                    paddingLeft: 8, paddingRight: 8,
                                                }}

                                                color="orange"
                                                size="xs"
                                                variant="filled"
                                                // style={{ zIndex: 1, paddingLeft: 8, paddingRight: 8, opacity: show ? 1 : 0, pointerEvents: show ? 'auto' : 'none', transition: 'opacity 150ms ease-in-out' }}
                                                styles={{
                                                    root: {
                                                        paddingLeft: 8,
                                                        paddingRight: 8
                                                    },
                                                    leftIcon: {
                                                        marginRight: 4
                                                    }
                                                }}
                                                leftIcon={
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6 7.33325V11.3333L7.33333 9.99992" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M6.00033 11.3333L4.66699 10" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M14.6663 6.66659V9.99992C14.6663 13.3333 13.333 14.6666 9.99967 14.6666H5.99967C2.66634 14.6666 1.33301 13.3333 1.33301 9.99992V5.99992C1.33301 2.66659 2.66634 1.33325 5.99967 1.33325H9.33301" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M14.6663 6.66658H11.9997C9.99967 6.66658 9.33301 5.99992 9.33301 3.99992V1.33325L14.6663 6.66658Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }
                                            >
                                                Download 360 file
                                            </Button> : null}

                                            {/* <Button
                                            
                                                style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    zIndex: 1,
                                                    backgroundColor: '#f53c02',
                                                    color: 'white'
                                                }}
                                                onClick={() => {
                                                    model.onUpscaleHdrV1(model.pipeline.params.srcset[0], '4k')
                                                }}

                                            >
                                                Upscale 4K
                                            </Button> */}
                                        </Flex>
                                    </Flex>
                                </>
                            ) : null
                        }
                    </Flex>
                ) : null
            }
        </Flex>
    );
}

export default observer(PipelineItem);